import { GIPHY_TYPE } from './../../ricos-content';

const giphyStrategy = () => ({
  config: {
    [GIPHY_TYPE]: {
      giphySdkApiKey: '8LVphUXpyDK77BY7BhYMXgFU6TwhSKkA',
    },
  },
});

export default giphyStrategy;
